"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const user_1 = require("./user");
const user_role_1 = require("./user-role");
const userAccessReducer = (0, redux_1.combineReducers)({
    userReducer: user_1.userReducer,
    userRoleReducer: user_role_1.userRoleReducer,
});
exports.default = userAccessReducer;
